import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { ENROL_LOYALTY_ACCOUNT } from 'actions/apiActionConstants'
import * as Analytics from 'analytics/analytics'
import { loyaltyContext } from 'analytics/snowplow/eventContexts/loyaltyContext'
import requestLoyaltyAccountEnrolment from 'api/loyalty/requestLoyaltyAccountEnrolment'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import config from 'constants/config'
import { appViewMessageHandler } from 'lib/window/webViewUtils'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'

interface EnrolLoyaltyAccount {
  accountMemberId?: string
  token?: string
  enableSnackbar?: boolean
  enrolment: App.LoyaltyEnrolmentType | undefined
}

function enrolLoyaltyAccount({ accountMemberId, token, enrolment }: EnrolLoyaltyAccount): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const memberId = accountMemberId ?? state.auth.account.memberId
    const givenName = state.auth.account.givenName
    const headlessMode = state.system.headlessMode
    const hasLoyaltyAccount = getHasLoyaltyAccount(state)
    const loyaltyAccount = state.loyalty.account

    let enrolled = false

    if (
      !getIsLoyaltyEnabled(state) ||
      !memberId ||
      hasLoyaltyAccount ||
      loyaltyAccount.fetching ||
      loyaltyAccount.error
    ) return

    dispatch({
      type: API_CALL,
      api: ENROL_LOYALTY_ACCOUNT,
      enrolment,
      request: () => requestLoyaltyAccountEnrolment({
        customerId: memberId,
      }, token)
        .then((result) => {
          enrolled = true
          let analyticsAction = 'default'

          if (enrolment === 'newUserRegistration') {
            analyticsAction = 'sign_up'
            showSnackbar(
              `Welcome to ${config.title} and your new ${getLoyaltyProgramDisplayName()} membership${givenName ? `, ${givenName}` : ''}. Start earning today.`,
              'success',
            )
          }

          if (enrolment === 'existingUserRegistration') {
            analyticsAction = 'opt_in'
            showSnackbar(
              `Welcome to your new ${getLoyaltyProgramDisplayName()} membership${givenName ? `, ${givenName}` : ''}. Start earning today.`,
              'success',
            )
          }

          if (result?.accountNumber) {
            Analytics.trackClientEvent({
              action: analyticsAction,
              category: 'loyalty_sign_up',
              subject: result.accountNumber + '_' + result.tier,
              type: 'operational',
              options: {
                contextsToSkip: [
                  'loyalty',
                ],
              },
              context: [
                loyaltyContext(result),
              ],
            },
            )
          }
          return result
        })
        .catch((err) => {
          showSnackbar(
            'Please try again later or contact us for assistance.',
            'critical',
            { heading: 'Oops! Something went wrong' },
          )

          throw err
        })
        .finally(() => {
          // Send message to mobile WebView
          if (headlessMode) {
            appViewMessageHandler('luxLoyalty', { enrolled })
          }
        }),
    })
  }
}

export default enrolLoyaltyAccount
